import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface DragDropOverlayProps {
  isDragging: boolean;
}

export default function DragDropOverlay({ isDragging }: DragDropOverlayProps) {
  const { t } = useTranslation();

  if (!isDragging) {
    return null;
  }

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-40 flex items-center justify-center",
        "rounded-lg border-2 border-dashed border-secondary bg-card/80 backdrop-blur-sm",
        "duration-150 animate-in fade-in",
      )}
    >
      <div className="flex flex-col items-center gap-2 text-muted-foreground">
        <Upload size={32} />
        <p className="text-sm font-medium">{t("dragAndDrop.dropToAttach")}</p>
      </div>
    </div>
  );
}
